import { render } from "./ControlMoreInfo.vue?vue&type=template&id=70a8bdbc"
import script from "./ControlMoreInfo.vue?vue&type=script&lang=js"
export * from "./ControlMoreInfo.vue?vue&type=script&lang=js"

import "./ControlMoreInfo.vue?vue&type=style&index=0&id=70a8bdbc&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__